import { Spinner } from 'reactstrap';

const LoadingSpinner = () => {
  return <Spinner type="grow" color="primary" className="m-5" />;
};

export default LoadingSpinner;
